module.exports = __webpack_public_path__ + "static/img/application8-3.cf170dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application8-3.jpg
// module id = kvmH
// module chunks = 0